const ASSET_PATHS = {
  logo: '/assets/images/logo.svg',
  menuIcon: '/assets/images/menu.svg',
  menuBlackIcon: '/assets/images/menu-black.svg',
  backIcon: '/assets/images/backIcon.svg',
  location: '/assets/images/location.svg',
  title: '/assets/images/title.svg',
  id: '/assets/images/id.svg',
  tablerProgress: '/assets/images/tabler_progress.svg',
  tablerProgressWhite: '/assets/images/tabler_progress-white.svg',
  refresh: '/assets/images/refresh.svg',
  pendingAction: '/assets/images/pending_action.svg',
  warning: '/assets/images/warning.svg',
  cloudUploadWhite: '/assets/images/cloud-upload-white.svg',
  cloudUpload: '/assets/images/cloud-upload.svg',
  checkCircleWhite: '/assets/images/check-circle-white.svg',
  clipboardCheck: '/assets/images/clipboard-check.svg',
  clipboardCheckWhite: '/assets/images/clipboard-check-white.svg',
  clipboardCheckGreen: '/assets/images/clipboard-check-green.svg',
  calendar: '/assets/images/calendar.svg',
  calendarWhite: '/assets/images/calendar-white.svg',
  checkCircle: '/assets/images/check-circle.svg',
  checkCircle2: '/assets/images/check-circle-2.svg',
  exclamationCircle: '/assets/images/exclamation-circle.svg',
  blockIcon: '/assets/images/block-icon.svg',
  blockIconBlue: '/assets/images/block-icon-blue.svg',
  closeIcon: '/assets/images/close-icon.svg',
  biUpcScan: '/assets/images/bi_upc-scan.svg',
  download: '/assets/images/download.svg',
  media: '/assets/images/material-symbols_perm-media-outline.svg',
  nuke: '/assets/images/nuke.svg',
  settings: '/assets/images/cog.svg',
  logout: '/assets/images/logout.svg',
  logout100: '/assets/images/logout-100.svg',
  checkCircleGrey: '/assets/images/check-circle-grey.svg',
  checkCircleGreen: '/assets/images/check-circle-green.svg',
  xCircle: '/assets/images/x-circle.svg',
  xCircleWhite: '/assets/images/x-circle-white.svg',
  trash: '/assets/images/trash.svg',
  trashLarge: '/assets/images/trash-large.svg',
  comment: '/assets/images/comment.svg',
  camera: '/assets/images/camera.svg',
  video: '/assets/images/video.svg',
  poster: '/assets/images/poster.svg',
  skipGrey: '/assets/images/skip-grey.svg',
  cameraWhite: '/assets/images/camera-white.svg',
  videoWhite: '/assets/images/video-white.svg',
  blueCrossIcon: '/assets/images/blue-cross-icon.svg',
  blueCameraIcon: '/assets/images/blue-camera-icon.svg',
  blueVideoIcon: '/assets/images/blue-video-icon.svg',
  photograph: '/assets/images/photograph.svg',
  bluePhotographIcon: '/assets/images/blue-photograph-icon.svg',
  blackGalleryIcon: '/assets/images/black-gallery.svg',
  edit: '/assets/images/pencil-alt.svg',
  editBlue: '/assets/images/blue-pencil-icon.svg',
  commentWhite: '/assets/images/comment-white.svg',
  editWhite: '/assets/images/pencil-white.svg',
  docWhiteIcon: '/assets/images/doc-icon-white.svg',
  locationWhiteIcon: '/assets/images/location-marker-white.svg',
  officeBuildingWhite: '/assets/images/office-building-white.svg',
  photographWhiteIcon: '/assets/images/photograph-white.svg',
  octiconSkip: '/assets/images/octicon_skip-16.svg',
  unSkip: '/assets/images/unskip-icon.svg',
  unSkip100: '/assets/images/unskip-icon-100.svg',
  uploadIcon: '/assets/images/upload-icon.svg',
  packageIcon: '/assets/images/cube.svg',
  packageBlueIcon: '/assets/images/cube-blue.svg',
  unskipGrey: '/assets/images/unskip-grey.svg',
  unskipWhite: '/assets/images/unskip-icon-white.svg',
  blockIconModule: '/assets/images/block-icon-module.svg',
};

export default ASSET_PATHS;